var module = angular.module('octopusApp.environments');

module.controller('MachinePolicyEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var machinePolicyId = $stateParams["id"];
    var repository = octopusRepository.MachinePolicies;

    $scope.machinePolicy = null;

    if (machinePolicyId) {
        isLoading.promise(repository.get(machinePolicyId).then(function (machinePolicy) {
            isLoading.promise(repository.getMachines(machinePolicy).then(function (response) {
                $scope.numberOfMachines = response.TotalResults;
                $scope.machinesUsingPolicy = response;
                $scope.machinePolicy = machinePolicy;
                refreshHealthCheckInterval();
                refreshDeleteMachinesElapsedTimeSpan();
                pageTitle(machinePolicy.Name);
            }));
        }));
    } else {
        $scope.numberOfMachines = 0;
        $scope.machinePolicy = {
            Name: "",
            Description: "",
            IsDefault: false,
            MachineHealthCheckPolicy: {
                TentacleEndpointHealthCheckPolicy: {
                    RunType: "InheritFromDefault",
                    ScriptBody: ""
                },
                SshEndpointHealthCheckPolicy: {
                    RunType: "InheritFromDefault",
                    ScriptBody: ""
                },
                HealthCheckInterval: "0.01:00"
            },
            MachineCleanupPolicy: {
                DeleteMachinesBehavior: "DoNotDelete",
                DeleteMachinesElapsedTimeSpan: "0.01:00"
            },
            MachineUpdatePolicy: {
                CalamariUpdateBehavior: "UpdateOnDeployment",
                TentacleUpdateBehavior: "NeverUpdate"
            },
            MachineConnectivityPolicy: {
                MachineConnectivityBehavior: "ExpectedToBeOnline"
            }
        };
        refreshHealthCheckInterval();
        refreshDeleteMachinesElapsedTimeSpan();
        pageTitle('Create Machine Policy');
    }

    function refreshHealthCheckInterval()
    {
        var healthCheckIntervalParts = $scope.machinePolicy.MachineHealthCheckPolicy.HealthCheckInterval.split(":");

        var days = 0;
        var hours = 0;
        var mins = 0;
        var tsPart1 = healthCheckIntervalParts[0];
        if (tsPart1.indexOf(".") !== -1) {
            // days included
            var daysAndHours = tsPart1.split(".");
            days = parseInt(daysAndHours[0]);
            hours = parseInt(daysAndHours[1]);
            mins = parseInt(healthCheckIntervalParts[1]);
        } else {
            // no days
            hours = parseInt(healthCheckIntervalParts[0]);
            mins = parseInt(healthCheckIntervalParts[1]);
        }
        $scope.healthCheckInterval = {
            Days: days,
            Hours: hours,
            Minutes: mins
        };
    }

    function refreshDeleteMachinesElapsedTimeSpan()
    {
        var deleteMachinesElapsedTimeSpanParts = $scope.machinePolicy.MachineCleanupPolicy.DeleteMachinesElapsedTimeSpan.split(":");

        var days = 0;
        var hours = 0;
        var mins = 0;
        var tsPart1 = deleteMachinesElapsedTimeSpanParts[0];
        if (tsPart1.indexOf(".") !== -1) {
            // days included
            var daysAndHours = tsPart1.split(".");
            days = parseInt(daysAndHours[0]);
            hours = parseInt(daysAndHours[1]);
            mins = parseInt(deleteMachinesElapsedTimeSpanParts[1]);
        } else {
            // no days
            hours = parseInt(deleteMachinesElapsedTimeSpanParts[0]);
            mins = parseInt(deleteMachinesElapsedTimeSpanParts[1]);
        }
        $scope.deleteMachinesElapsedTimeSpan = {
            Days: days,
            Hours: hours,
            Minutes: mins
        };
    }

    $scope.save = function() {

        if ($scope.deleteMachinesElapsedTimeSpan.Days == null) {
            $scope.deleteMachinesElapsedTimeSpan.Days = 0;
        }
        if ($scope.deleteMachinesElapsedTimeSpan.Hours == null) {
            $scope.deleteMachinesElapsedTimeSpan.Hours = 0;
        }
        if ($scope.deleteMachinesElapsedTimeSpan.Minutes == null) {
            $scope.deleteMachinesElapsedTimeSpan.Minutes = 0;
        }
        $scope.machinePolicy.MachineCleanupPolicy.DeleteMachinesElapsedTimeSpan = $scope.deleteMachinesElapsedTimeSpan.Days + "." + pad($scope.deleteMachinesElapsedTimeSpan.Hours) + ":" + pad($scope.deleteMachinesElapsedTimeSpan.Minutes) + ":00";

        if ($scope.healthCheckInterval.Days == null) {
            $scope.healthCheckInterval.Days = 0;
        }
        if ($scope.healthCheckInterval.Hours == null) {
            $scope.healthCheckInterval.Hours = 0;
        }
        if ($scope.healthCheckInterval.Minutes == null) {
            $scope.healthCheckInterval.Minutes = 0;
        }
        $scope.machinePolicy.MachineHealthCheckPolicy.HealthCheckInterval = $scope.healthCheckInterval.Days + "." + pad($scope.healthCheckInterval.Hours) + ":" + pad($scope.healthCheckInterval.Minutes) + ":00";

        isSaving.promise(repository.save($scope.machinePolicy).then(function(saved){
            unsavedChanges.saved();
            $location.path('/environments/machinepolicies/');
        }));
    };

    function pad(num){
        return ("00" + num).substr(-2);
    }
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machinepolicies/controllers/machine_policy_edit_controller.js
// module id = 434
// module chunks = 1